module.exports = __webpack_public_path__ + "static/media/add_new.fc6a50a2.png";